const products = [
  {
    tag: 'SECURITY',
    name: 'VPN',
    tagline: 'Private & Secure Browsing',
    description:
      'Protect your online identity with military-grade encryption. Our VPN app routes your traffic through secure servers worldwide, keeping your data safe from prying eyes on any network.',
    features: ['256-bit AES Encryption', 'No-Log Policy', 'Global Server Network', 'Kill Switch Protection'],
    image: 'https://public.readdy.ai/ai/img_res/3360100d02c788b85d423172e2359a84.jpg',
    dark: true,
  },
  {
    tag: 'OPTIMIZATION',
    name: 'Cleaner',
    tagline: 'Speed Up Your iPhone',
    description:
      'Reclaim storage and boost performance with our intelligent Cleaner app. Automatically detects junk files, duplicate photos, and unused caches to keep your device running at peak speed.',
    features: ['Smart Junk Detection', 'Duplicate Photo Finder', 'Cache Cleaner', 'Memory Booster'],
    image: 'https://readdy.ai/api/search-image?query=smartphone%20cleaning%20optimization%20concept%20with%20sparkling%20light%20particles%20and%20clean%20white%20background%2C%20abstract%20speed%20and%20performance%20art%2C%20soft%20teal%20and%20white%20tones%2C%20minimalist%20modern%20illustration%2C%20no%20text%2C%20professional%20tech%20aesthetic&width=600&height=700&seq=cleaner001&orientation=portrait',
    dark: false,
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="text-teal-500 text-xs font-semibold tracking-widest uppercase">Our Products</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Innovative Solutions
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Designed for modern iOS users who demand performance, privacy, and simplicity.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.name}
              className={`rounded-3xl overflow-hidden flex flex-col md:flex-row ${
                product.dark ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'
              }`}
            >
              {/* Text */}
              <div className="flex-1 p-10 flex flex-col justify-between">
                <div>
                  <span
                    className={`text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full ${
                      product.dark
                        ? 'bg-teal-500/20 text-teal-400'
                        : 'bg-teal-100 text-teal-600'
                    }`}
                  >
                    {product.tag}
                  </span>
                  <h3 className="text-5xl font-bold mt-5 mb-2">{product.name}</h3>
                  <p className={`text-sm font-medium mb-4 ${product.dark ? 'text-teal-400' : 'text-teal-600'}`}>
                    {product.tagline}
                  </p>
                  <p className={`text-sm leading-relaxed mb-8 ${product.dark ? 'text-gray-400' : 'text-gray-600'}`}>
                    {product.description}
                  </p>
                </div>
                <ul className="space-y-2">
                  {product.features.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-sm">
                      <span className={`w-5 h-5 flex items-center justify-center rounded-full ${product.dark ? 'bg-teal-500/20' : 'bg-teal-100'}`}>
                        <i className="ri-check-line text-teal-500 text-xs" />
                      </span>
                      <span className={product.dark ? 'text-gray-300' : 'text-gray-700'}>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Image */}
              <div className="w-full md:w-56 h-64 md:h-auto flex-shrink-0">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
